/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useRef, useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { Spinner } from '@intigral/shared';

interface SelectProfileLoaderProps {
    loadingProfile?: any;
    autoCloseLoading?: any;
    onClose?: () => void;
    onSuccess?: () => void;
}

const SelectProfileLoader: React.FC<SelectProfileLoaderProps> = ({
    loadingProfile = false,
    autoCloseLoading = false,
    onClose = () => {},
}) => {
    const popupRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!popupRef.current) {
            return;
        }
        // disable body scroll on show popup
        if (loadingProfile && popupRef?.current) {
            // auto close loading popup
            if (autoCloseLoading) {
                setTimeout(() => {
                    if (popupRef.current) popupRef.current.style.display = 'none';
                    onClose();
                }, autoCloseLoading);
            }
            disableBodyScroll(popupRef?.current);
        } else {
            if (popupRef?.current) {
                enableBodyScroll(popupRef?.current);
            }
            clearAllBodyScrollLocks();
        }
    }, [autoCloseLoading, loadingProfile, popupRef?.current]);

    return (
        <>
            {loadingProfile && loadingProfile !== null && (
                <div ref={popupRef}>
                    <Spinner opaqueBg />
                </div>
            )}
        </>
    );
};

export default SelectProfileLoader;
